(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .service('FreightPaymentCustomService', FreightPaymentCustomService);

    FreightPaymentCustomService.$inject = ['$http'];

    function FreightPaymentCustomService($http) {
        var service = {
            returnUsedShipments: returnUsedShipments,
            returnAvailableShipments: returnAvailableShipments,
            returnFreightPaymentInfoForNewShipment: returnFreightPaymentInfoForNewShipment,
            returnFreightPaymentsByShipment: returnFreightPaymentsByShipment,
            returnFreightPaymentsWithNoShipmentByBlNumber: returnFreightPaymentsWithNoShipmentByBlNumber,
            returnRelatedFreightPayments: returnRelatedFreightPayments,
            returnFreightPaymentsByBlNumber: returnFreightPaymentsByBlNumber,
            returnFreightPaymentsByBlNumbers: returnFreightPaymentsByBlNumbers,
            saveImportFreightPayments: saveImportFreightPayments
        };

        return service;

        function returnUsedShipments() {
            var url = "api/shipments/freight-payment/filter";
            return $http.get(url);
        }

        function returnAvailableShipments() {
            var url = "api/shipments/freight-payment/available";
            return $http.get(url);
        }

        function returnFreightPaymentInfoForNewShipment(id) {
            var url = "api/freight-payments/shipment/info/" + id;
            return $http.get(url);
        }

        function returnFreightPaymentsByShipment(shipmentId) {
            var url = "api/freight-payments/shipment/" + shipmentId;
            return $http.get(url);
        }

        function returnFreightPaymentsWithNoShipmentByBlNumber(blNumber) {
            var url = "api/freight-payments/shipment/blnumber/" + blNumber;
            return $http.get(url);
        }

        function returnRelatedFreightPayments(fpId, shipmentId) {
            var url = "api/freight-payments/" + fpId + "/related/shipment/" + shipmentId;
            return $http.get(url);
        }

        function returnFreightPaymentsByBlNumber(blNumber) {
            var url = "api/freight-payments/minified/blNum/" + blNumber;
            return $http.get(url);
        }

        function returnFreightPaymentsByBlNumbers(blNumbers) {
            var url = "api/freight-payments/minified/blNum/bulk?blNums=" + blNumbers;
            return $http.get(url);
        }

        function saveImportFreightPayments(fps) {
            var url = "api/freight-payments/import";
            return $http({
                url: url,
                method: "POST",
                data: fps,
                headers: {'Content-Type':'application/json'}
            });
        }
    }
})();
